module.exports = __webpack_public_path__ + "img/1440.dd78dbc4.jpg";